import React from 'react';

class Question extends React.Component {
  state = {
    completed: false,
  };

  checkforcompletion = () => {
    if (!this.props.question.singleChoice) {
      let completed = false;
      for (let element of this.props.question.choices) {
        if (element.selected == true) {
          completed = true;
          break;
        }
      }
      this.setState({
        completed,
      });
    }
  };

  checkIfAnswered = () => {
    if (!this.props.question.answered) {
      this.props.question.answered = true;
      this.props.increaseBar(this.props.question.key, true, this.props.question.question);
    } else {
      this.props.increaseBar(this.props.question.key, false, this.props.question.question);
    }
  };

  selectAswers = (choice) => {
    if (this.props.question.singleChoice) {
      this.props.question.choices.forEach((element) => {
        if (element.selected == true) {
          element.selected = false;
        }
      });
      this.checkIfAnswered();
    }
    if (choice.selected == true) {
      choice.selected = false;
    } else {
      choice.selected = true;
    }
    this.checkforcompletion();
  };

  renderQuestionWithImg = () => {
    return (
      <div className="QuestionCotainer__block-questionlistBig">
        {this.props.question.choices.map((choice) => {
          return (
            <div
              onClick={() => this.selectAswers(choice)}
              key={choice.key}
              className={` QuestionCotainer__block-questionlistBig-Item ${
                choice.selected == true ? 'QuestionCotainer__block-questionlistBig-Item-selected' : ''
              }`}
            >
              <img
                src={choice.selected == true ? choice.activePng : choice.inactivePng}
                className="QuestionCotainer__block-questionlistBig-Item-img"
              />
              <div className="QuestionCotainer__block-questionlistBig-Item-body">
                <div className="QuestionCotainer__block-questionlistBig-Item-body-checkbox-outer">
                  <div
                    className={`${
                      choice.selected == true
                        ? 'QuestionCotainer__block-questionlistBig-Item-body-checkbox-inner-1'
                        : 'QuestionCotainer__block-questionlistBig-Item-body-checkbox-inner-1-invisible'
                    }`}
                  />
                  <div
                    className={`${
                      choice.selected == true
                        ? 'QuestionCotainer__block-questionlistBig-Item-body-checkbox-inner-2'
                        : 'QuestionCotainer__block-questionlistBig-Item-body-checkbox-inner-2-invisible'
                    }`}
                  />
                </div>
                <div className="QuestionCotainer__block-questionlistBig-Item-body-text">{choice.answer}</div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    return (
      <div className="QuestionCotainer">
        <div className="QuestionCotainer__number">{this.props.question.key}.</div>
        <div className="QuestionCotainer__block">
          <div className="QuestionCotainer__block-question">{this.props.question.question}</div>
          <div className="QuestionCotainer__block-description">{this.props.question.description}</div>
          {!this.props.question.singleChoice ? (
            <div className="QuestionCotainer__block-chose">Choose as many as you like</div>
          ) : (
            <div style={{ display: 'none' }} />
          )}
          {this.props.question.key == 2 ? (
            this.renderQuestionWithImg()
          ) : (
            <div className="QuestionCotainer__block-questionlist">
              {this.props.question.choices.map((choice) => {
                return (
                  <div
                    key={choice.key}
                    onClick={() => this.selectAswers(choice)}
                    className={`QuestionCotainer__block-questionlist-Item ${
                      choice.selected == true ? 'QuestionCotainer__block-questionlist-Item-selected' : ''
                    }`}
                  >
                    {choice.answer}
                    <div className="QuestionCotainer__block-questionlist-Item-checkmark-1" />
                    <div className="QuestionCotainer__block-questionlist-Item-checkmark-2" />
                  </div>
                );
              })}
            </div>
          )}
          {!this.props.question.singleChoice && this.state.completed ? (
            <button onClick={this.checkIfAnswered} className="QuestionCotainer__block-button">
              Okay!
            </button>
          ) : (
            <div style={{ display: 'none' }} />
          )}
        </div>
      </div>
    );
  }
}

export default Question;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/onboarding/question.js